import { render } from "./RenameAction.vue?vue&type=template&id=34bd4e60"
import script from "./RenameAction.vue?vue&type=script&lang=ts"
export * from "./RenameAction.vue?vue&type=script&lang=ts"
script.render = render

export default script